import { render } from "./AdminSidebar.vue?vue&type=template&id=bd054b6a&ts=true"
import script from "./AdminSidebar.vue?vue&type=script&lang=ts"
export * from "./AdminSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__